import React from 'react';

import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { primitive, spacing } from 'styles/constants';

import { ErrorText } from './error-text';
import { GrandTotalText } from './grand-total-text';
import { PlaceOrderButton } from './place-order-button';
import { CheckoutFooterProps } from './types';

export const CheckoutFooter: React.FC<CheckoutFooterProps> = () => {
  const { bottom } = useSafeAreaInsets();
  // TODO: check whether the same layout can serve both cart and checkout.
  // since in the cart we’re putting all the components inside a card-modal, unlike in checkout.
  // https://github.com/rbilabs/bk-us-app/blob/0448746347a94aa18300cbde7bb948ea2525fc8a/src/components/card-modal.tsx#L129
  const paddingBottom = bottom || spacing.$4;

  return (
    <View style={styles.wrapper}>
      <View style={[styles.container, { paddingBottom }]}>
        <ErrorText />
        <GrandTotalText />
        <PlaceOrderButton />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  // TODO: consider sharing this FooterComponent between cart and checkout.
  // The current footer component from components/ui is also used in a modal which im not sure if this is right.
  // Using common styles here for now.
  // NOTE: booth cart and checkout should use same style system. Currently cart is using the old UCL style system.
  // https://rbictg.atlassian.net/browse/BKPE-15723
  wrapper: {
    alignItems: 'center',
    backgroundColor: primitive.$white,
  },
  container: {
    paddingVertical: spacing.$4,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: 560,
  },
});
